/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Arrayscape Gaming Dashboard API
 * Comprehensive REST API for event management, business operations, and analytics
 * OpenAPI spec version: 1.0.0
 */

export type TimesheetStatus = typeof TimesheetStatus[keyof typeof TimesheetStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimesheetStatus = {
  TimesheetStatusDraft: 'draft',
  TimesheetStatusSubmitted: 'submitted',
  TimesheetStatusApproved: 'approved',
  TimesheetStatusRejected: 'rejected',
  TimesheetStatusProcessing: 'processing',
  TimesheetStatusPaid: 'paid',
} as const;
